import AWS from 'aws-sdk';
import { configuration } from '@/api/aws-exports.js';
import { Auth } from 'aws-amplify';
import { log } from '@/constants.js';
import 'ol/ol.css';

export const state = {
  map: null,
  overlay: false
};

export const mutations = {};

// ---------------------- GETTERS ---------------------
export const getters = {
  getCredentials: state => id => {
    return state.services.filter(service => service.service_id === id);
  }
};

// ---------------------- SERVICES ---------------------
export const actions = {
  addMsgs({ commit }, data) {
    commit('pushMsgs', data);
  },
  async setCredentials({ dispatch }) {
    try {
      const session = await Auth.currentSession();
      AWS.config.region = configuration.aws_project_region;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: configuration.aws_cognito_identity_pool_id,
        Logins: {
          [`cognito-idp.${configuration.aws_project_region}.amazonaws.com/${configuration.Auth.userPoolId}`]: session
            .getIdToken()
            .getJwtToken()
        }
      });
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'setCredentials',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async refreshToken({ dispatch }) {
    try {
      setInterval(async () => {
        const session = await Auth.currentSession();
        const refresh_token = session.getRefreshToken(); // you'll get session from calling cognitoUser.getSession
        const cognitoUser = await Auth.currentAuthenticatedUser();
        cognitoUser.refreshSession(refresh_token, (err, session) => {
          if (err) {
            dispatch(
              'storeToastMessage',
              {
                text: 'refreshToken cognitoUser.refreshSession',
                errObj: err,
                type: 'danger'
              },
              { root: true }
            );
          } else {
            AWS.config.credentials.params.Logins[
              `cognito-idp.${configuration.aws_project_region}.amazonaws.com/${configuration.Auth.userPoolId}`
            ] = session.getIdToken().getJwtToken();
            AWS.config.credentials.refresh(err => {
              if (err) {
                dispatch(
                  'storeToastMessage',
                  {
                    text: 'refreshToken AWS.config.credentials',
                    errObj: err,
                    type: 'danger'
                  },
                  { root: true }
                );
              } else {
                log.info('TOKEN SUCCESSFULLY UPDATED');
              }
            });
          }
        });
      }, 3000000);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'refreshToken',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  }
};
